import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=40caf5bb&scoped=true"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40caf5bb",
  null
  
)

export default component.exports